import { FormGroup } from "../../../../components/form";
import * as yup from "yup";

export const appealRequestFormLegacy: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Appeal Request Details",
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "appealReason",
      label: "Reason for Appeal",
      validation: yup.string().trim().required("A response is required"),
      warn: "Outline the reason/s for the appeal",
    },
    {
      type: "field",
      key: "internalNotes",
      fieldType: "textarea",
      label: "Internal notes",
      props: {
        rows: 5,
        col: 30,
        autoResize: true,
      },
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "warning ",
      },
      label:
        "When you save your request, this application will become read-only and a new appeal application will be created. All relevant information will be copied from this application to the appeal. The appeal review will be undertaken in the new appeal application.",
    },
    {
      type: "field",
      key: "appealApplicationId",
      fieldType: "button",
      label: "Open Appeal Application",
      props: {
        className: "form-button",
        disabled: false,
      },
      expressionProps: {
        onClick: (context) => () => window.open(`/applications/applicationBaseLegacy/${context.nextApplicationId}`, "_blank"),
      },
      hideExpression: (context) => !context.hasAppeal,
    },
  ],
};
